import { useSelector } from 'react-redux'
import Numeral from '../numeral'

import { StyledProductsSummary } from './style'

const ProductsSummary = () => {
  const subscription = useSelector((state) => state.subscription)
  const products = subscription.products

  return (
    <StyledProductsSummary>
      {Object.keys(products).map((id, i) => (
        <span key={i}>
          <strong><Numeral value={products[id].price} format="$ 0,0.00" /></strong>
          <small>{products[id].quantity} x {products[id].name}</small>
        </span>
      ))}
    </StyledProductsSummary>
  )
}

export default ProductsSummary
